import React, { useEffect, createElement } from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { HowItWorks } from './components/HowItWorks';
import { BenefitsSection } from './components/BenefitsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { FAQSection } from './components/FAQSection';
import { BuySection } from './components/BuySection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
export function App() {
  useEffect(() => {
    document.title = 'Xclusive Agent Leads';
    // Meta Pixel base code
    if (!window.fbq) {
      const f: any = window.fbq = function (...args: any[]) {
        f.callMethod ? f.callMethod(...args) : f.queue.push(args);
      };
      if (!window._fbq) window._fbq = f;
      f.push = f;
      f.loaded = true;
      f.version = '2.0';
      f.queue = [];
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    window.fbq('init', '1383554687105897');
    window.fbq('track', 'PageView');
    // noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1383554687105897&ev=PageView&noscript=1';
    noscript.appendChild(img);
    document.body.appendChild(noscript);
    // Track pixel events on CTA clicks
    const handleClick = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest('a');
      if (!target) return;
      const href = target.getAttribute('href') || '';
      // Schedule event for booking / agendar links
      if (href.includes('leadconnectorhq.com') || href.includes('#agendar')) {
        window.fbq?.('track', 'Schedule', {
          content_name: 'Book Call',
          content_category: 'Booking',
          destination: 'leadconnector'
        });
      }
      // InitiateCheckout event for "Comprar Leads" store links
      if (href.includes('xclusiveagentleads.com')) {
        window.fbq?.('track', 'InitiateCheckout', {
          content_name: 'Comprar Leads',
          content_category: 'Store',
          destination: 'xclusiveagentleads'
        });
      }
    };
    document.addEventListener('click', handleClick);
    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, []);
  return <div className="min-h-screen bg-brand-charcoal font-sans selection:bg-brand-orange selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <HowItWorks data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <BuySection data-id="element-6" />
        <TestimonialsSection data-id="element-7" />
        <FAQSection data-id="element-8" />
        <CTASection data-id="element-9" />
      </main>
      <Footer data-id="element-10" />
    </div>;
}